<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col>
              <list-report-head :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                  {{ $t('assitive_device_management.donation_receive_details') }}
              </list-report-head>
              </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" sm="12">
                    <b-table-simple hover small caption-top>
                            <b-tr>
                                <b-th style="width:15%">{{ $t('globalTrans.fiscal_year') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ ($i18n.locale=='bn') ? formData.year_name_bn : formData.year_name }}</b-td>
                                <b-th style="width:15%">{{ $t('assitive_device_management.month') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ ($i18n.locale=='bn') ? formData.month_name_bn : formData.month_name }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th style="width:15%">{{ $t('assitive_device_management.donation_form') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ ($i18n.locale=='bn') ? formData.donation_form_bn : formData.donation_form }}</b-td>
                                <b-th style="width:15%">{{ $t('assitive_device_management.donor_details') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ ($i18n.locale=='bn') ? formData.donor_description : formData.donor_description }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-th style="width:15%">{{ $t('assitive_device_management.donation_type') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ ($i18n.locale=='bn') ? formData.donation_type_name_bn : formData.donation_type_name }}</b-td>
                                <b-th v-if="formData.donation_type_id === 1" style="width:15%">{{ $t('assitive_device_management.assistive_device_name') }}</b-th>
                                <th v-if="formData.donation_type_id === 1" class="text-center" style="width: 2%">:</th>
                                <b-td v-if="formData.donation_type_id === 1" style="width:33%">{{ ($i18n.locale=='bn') ? formData.device_name_bn : formData.device_name_bn }}</b-td>
                                <b-th v-if="formData.donation_type_id === 2" style="width:15%">{{ $t('assitive_device_management.amount') }}</b-th>
                                <th v-if="formData.donation_type_id === 2" class="text-center" style="width: 2%">:</th>
                                <b-td v-if="formData.donation_type_id === 2" style="width:33%">{{ $n(formData.amount) }}</b-td>
                                <b-th v-if="formData.donation_type_id === 3" style="width:15%">{{ $t('assitive_device_management.quantity_pice') }}</b-th>
                                <th v-if="formData.donation_type_id === 3" class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">
                                    <slot v-if="formData.donation_type_id === 3">{{ $n(formData.medicine_quantity) }}</slot>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th v-if="formData.donation_type_id === 1" style="width:15%">{{ $t('assitive_device_management.quantity_pice') }}</b-th>
                                <th v-if="formData.donation_type_id === 1" class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%" colspan="4">
                                    <slot v-if="formData.donation_type_id === 1">{{ $n(formData.device_quantity) }}</slot>
                                </b-td>
                            </b-tr>
                            <b-tr>
                                <b-th style="width:15%">{{ $t('globalTrans.description') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ formData.description }}</b-td>
                                <b-th style="width:15%">{{ $t('assitive_device_management.idsc_center') }}</b-th>
                                <th class="text-center" style="width: 2%">:</th>
                                <b-td style="width:33%">{{ currentLocale === 'en' ? formData.center_name : formData.center_name_bn }}</b-td>
                            </b-tr>
                    </b-table-simple>
                </b-col>
              </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { awarenessEventServiceBaseUrl } from '@/config/api_config'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export_pdf_details'

export default {
  props: ['item'],
  components: {
    ListReportHead
  },
  data () {
    return {
      formData: [],
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl
    }
  },
  created () {
    this.formData = this.item
  },
  mounted () {
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    pdfExport () {
      const reportTitle = this.$t('assitive_device_management.donation_receive_details')
      ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.formData, this)
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
